import { createEvent, sample } from 'effector'
import { fx } from '../../../libs'
import {
  setRequestError,
  setRequestSuccess,
} from '../../../features/notifications'

export const groupClientPurseMounted = createEvent<{
  clientPursesIds?: number[]
  groupsIds?: number[]
  mainPurseId: number
}>()

export const groupClientPurse = fx<
  {
    clientPursesIds?: number[]
    groupsIds?: number[]
    mainPurseId: number
  },
  any
>({
  method: 'POST',
  url: `/client_purse/group_client_purse`,
})

// @ts-ignore
sample({
  clock: groupClientPurseMounted,
  fn: ({ clientPursesIds, groupsIds, mainPurseId }) => {
    return {
      url: '/client_purse/group_client_purse',
      body: {
        clientPursesIds,
        groupsIds,
        mainPurseId,
      },
    }
  },
  target: groupClientPurse,
})

// @ts-ignore
sample({
  clock: groupClientPurse.doneData,
  fn: () => {
    return true
  },
  target: [setRequestSuccess],
})

// @ts-ignore
sample({
  clock: groupClientPurse.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setRequestError],
})
